'use client';

import Image from 'next/image';
import React from 'react';

type ItemType = {
  url: string;
  src: string;
  alt: string;
};

type CategoryProps = {
  title: string;
  items: ItemType[];
};

const ListingCategories: React.FC<CategoryProps> = ({ items, title }) => {
  return (
    <section className="px-5 py-16 md:py-32">
      <div className="max-w-[1250px] w-full mx-auto">
        <h2 className="font-semibold text-[30px] md:text-[36px] text-center mb-16">
          {title}
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10 lg:gap-24">
          {items.map(({ src, alt, url }, index) => (
            <a key={index} href={url} className="block group" target="_blank" rel="noopener noreferrer">
              <Image
                src={src}
                alt={alt}
                width={200}
                height={200}
                loading="lazy"
                className="w-[220px] sm:w-[300px] lg:w-full transition duration-300 group-hover:grayscale"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ListingCategories;
